/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EfsMelcoEfsModelsMappingCondition,
    EfsMelcoEfsModelsMappingConditionFromJSON,
    EfsMelcoEfsModelsMappingConditionFromJSONTyped,
    EfsMelcoEfsModelsMappingConditionToJSON,
    EfsMelcoEfsModelsMappingGroup,
    EfsMelcoEfsModelsMappingGroupFromJSON,
    EfsMelcoEfsModelsMappingGroupFromJSONTyped,
    EfsMelcoEfsModelsMappingGroupToJSON,
    EfsMelcoEfsModelsMappingOutput,
    EfsMelcoEfsModelsMappingOutputFromJSON,
    EfsMelcoEfsModelsMappingOutputFromJSONTyped,
    EfsMelcoEfsModelsMappingOutputToJSON,
    EfsMelcoModelsCustomWarning,
    EfsMelcoModelsCustomWarningFromJSON,
    EfsMelcoModelsCustomWarningFromJSONTyped,
    EfsMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface EfsMelcoEfsModelsMapping
 */
export interface EfsMelcoEfsModelsMapping {
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsMapping
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsMapping
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EfsMelcoEfsModelsMapping
     */
    global?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EfsMelcoEfsModelsMapping
     */
    configured?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsMapping
     */
    config_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsMapping
     */
    format_id?: string | null;
    /**
     * 
     * @type {Array<EfsMelcoEfsModelsMappingCondition>}
     * @memberof EfsMelcoEfsModelsMapping
     */
    conditions?: Array<EfsMelcoEfsModelsMappingCondition> | null;
    /**
     * 
     * @type {Array<EfsMelcoEfsModelsMappingOutput>}
     * @memberof EfsMelcoEfsModelsMapping
     */
    outputs?: Array<EfsMelcoEfsModelsMappingOutput> | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsMapping
     */
    service_type?: string | null;
    /**
     * 
     * @type {Array<EfsMelcoEfsModelsMappingGroup>}
     * @memberof EfsMelcoEfsModelsMapping
     */
    folder_groups?: Array<EfsMelcoEfsModelsMappingGroup> | null;
    /**
     * 
     * @type {Array<EfsMelcoModelsCustomWarning>}
     * @memberof EfsMelcoEfsModelsMapping
     */
    warning_list?: Array<EfsMelcoModelsCustomWarning> | null;
}

export function EfsMelcoEfsModelsMappingFromJSON(json: any): EfsMelcoEfsModelsMapping {
    return EfsMelcoEfsModelsMappingFromJSONTyped(json, false);
}

export function EfsMelcoEfsModelsMappingFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoEfsModelsMapping {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'global': !exists(json, 'global') ? undefined : json['global'],
        'configured': !exists(json, 'configured') ? undefined : json['configured'],
        'config_type': !exists(json, 'config_type') ? undefined : json['config_type'],
        'format_id': !exists(json, 'format_id') ? undefined : json['format_id'],
        'conditions': !exists(json, 'conditions') ? undefined : (json['conditions'] === null ? null : (json['conditions'] as Array<any>).map(EfsMelcoEfsModelsMappingConditionFromJSON)),
        'outputs': !exists(json, 'outputs') ? undefined : (json['outputs'] === null ? null : (json['outputs'] as Array<any>).map(EfsMelcoEfsModelsMappingOutputFromJSON)),
        'service_type': !exists(json, 'service_type') ? undefined : json['service_type'],
        'folder_groups': !exists(json, 'folder_groups') ? undefined : (json['folder_groups'] === null ? null : (json['folder_groups'] as Array<any>).map(EfsMelcoEfsModelsMappingGroupFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(EfsMelcoModelsCustomWarningFromJSON)),
    };
}

export function EfsMelcoEfsModelsMappingToJSON(value?: EfsMelcoEfsModelsMapping | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'global': value.global,
        'configured': value.configured,
        'config_type': value.config_type,
        'format_id': value.format_id,
        'conditions': value.conditions === undefined ? undefined : (value.conditions === null ? null : (value.conditions as Array<any>).map(EfsMelcoEfsModelsMappingConditionToJSON)),
        'outputs': value.outputs === undefined ? undefined : (value.outputs === null ? null : (value.outputs as Array<any>).map(EfsMelcoEfsModelsMappingOutputToJSON)),
        'service_type': value.service_type,
        'folder_groups': value.folder_groups === undefined ? undefined : (value.folder_groups === null ? null : (value.folder_groups as Array<any>).map(EfsMelcoEfsModelsMappingGroupToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(EfsMelcoModelsCustomWarningToJSON)),
    };
}


